import { render } from "./Story.vue?vue&type=template&id=c70769b4"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/demonology/demonology/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__